module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "BabyFace.82a806fb.png";